// src/index.ts
var isEdgeToEdge = () => true;
var controlEdgeToEdgeValues = (values) => {
};

export { controlEdgeToEdgeValues, isEdgeToEdge };
//# sourceMappingURL=index.mjs.map
//# sourceMappingURL=index.mjs.map